import React, { useState} from 'react'

const ChangeData = (props) => {
    const [ fullStandardVanRoute, setFullStandardVanRoute ] = useState(props.fullStandardVanRoute)
    const [ fullLargeVanRoute, setFullLargeVanRoute ] = useState(props.fullLargeVanRoute)
    const [ transportationRoute, setTransportationRoute ] = useState(props.transportationRoute)
    const [ mFNRoute, setMFNRoute ] = useState(props.mFNRoute)
    const [ manager, setManager ] = useState(props.manager)
    const [ missortRoute, setMissortRoute ] = useState(props.missortRoute)
    const [ classroomTraining, setClassroomTraining ] = useState(props.classroomTraining)
    const [ rideAlong, setRideAlong ] = useState(props.rideAlong)
    const [ sweeper, setSweeper ] = useState(props.sweeper)
    const [ mileRate, setMileRate] = useState(props.mileRate)
    const [ startingNumber, setStartingNumber ] = useState(0)

    // function for handling the changes
    const handleChange = (e) => {
        switch (e.target.name) {
            case 'fullStandardVanRoute':
                setFullStandardVanRoute(e.target.value)
                break;
            case 'fullLargeVanRoute':
                setFullLargeVanRoute(e.target.value)
                break;
            case 'transportationRoute':
                setTransportationRoute(e.target.value)
                break;
            case 'mFNRoute':
                setMFNRoute(e.target.value)
                break;
            case 'manager':
                setManager(e.target.value)
                break;
            case 'missortRoute':
                setMissortRoute(e.target.value)
                break;
            case 'classroomTraining':
                setClassroomTraining(e.target.value)
                break;
            case 'rideAlong':
                setRideAlong(e.target.value)
                break;
            case 'sweeper':
                setSweeper(e.target.value)
                break;
            case 'mileRate':
                setMileRate(e.target.value)
                break;
            default:
                console.log('error')    
        }
    }

    // handle submitting data
    const handleSubmit = () => {
        props.handleReturnData(
            parseFloat(fullStandardVanRoute),
            parseFloat(fullLargeVanRoute), 
            parseFloat(transportationRoute), 
            parseFloat(mFNRoute), 
            parseFloat(manager), 
            parseFloat(missortRoute), 
            parseFloat(classroomTraining), 
            parseFloat(rideAlong), 
            parseFloat(sweeper),
            parseInt(startingNumber),
            parseFloat(mileRate)
        )
    }

    // handle changing the starting number
    const handleChangeStart = (e) => {
        setStartingNumber(e.target.value)
    }

    return (
        <>
        <div className='initialStartingPoint'>
            <h2>Starting Invoice Number</h2>
            <h3>Input Number <input type="text" value={startingNumber} onChange={handleChangeStart}/></h3>
        </div>
            <div className='changeDataContainer'>
                <h2>Routes</h2>
                <h3>Full Standard Van Route: <input type="text" name='fullStandardVanRoute' value={fullStandardVanRoute} onChange={handleChange}/></h3>
                <h3>Full Large Van Route: <input type="text" name='fullLargeVanRoute' value={fullLargeVanRoute} onChange={handleChange}/></h3>
                {/* <h3>Transportation Route: <input type="text" name='transportationRoute' value={transportationRoute} onChange={handleChange}/></h3> */}
                {/* <h3>MFN Route: <input type="text" name='mFNRoute' value={mFNRoute} onChange={handleChange}/></h3> */}
                <h3>Manager: <input type="text" name='manager' value={manager} onChange={handleChange} /></h3>
                {/* <h3>Missort Route: <input type="text" name='missortRoute' value={missortRoute} onChange={handleChange}/></h3> */}
                <h3>Classroom Training: <input type="text" name='classroomTraining' value={classroomTraining} onChange={handleChange}/></h3>
                <h3>Ride Along: <input type="text" name='rideAlong' value={rideAlong} onChange={handleChange}/></h3>
                {/* <h3>Sweeper: <input type="text" name='sweeper' value={sweeper} onChange={handleChange}/></h3> */}
                <h3>Mile Rate: <input type="text" name='mileRate' value={mileRate} onChange={handleChange}/></h3>
                <button className='errorButtonSubmit' onClick={handleSubmit}>Submit</button>
            </div>
        </>
    )
}

export default ChangeData